import { h, Fragment } from "preact";

import css from "./PoweredBy3Play.module.css";
import Icon from "./Icon";

export function PoweredBy3Play() {
  return (
    <a href="https://www.3playmedia.com/" class={css.poweredBy}>
      <span>Powered by</span>
      <Icon type="logo-black" style={css.svg} />
    </a>
  );
}
